import { useMemo } from 'react';
import { useAuth } from '@/hooks/useAuth';
import {
  formatUserDate,
  formatUserDateShort,
  formatUserDateTime,
  type UserRegionalPrefs,
} from '@/utils/dateTime';

export function useUserRegionalPrefs() {
  const { user } = useAuth();

  const prefs: UserRegionalPrefs = useMemo(
    () => ({
      locale: (user as any)?.locale,
      timezone: (user as any)?.timezone,
      dateFormat: (user as any)?.dateFormat,
    }),
    [user],
  );

  return {
    prefs,
    formatDate: (value: string | Date | null | undefined) => formatUserDate(value, prefs),
    formatDateShort: (value: string | Date | null | undefined) => formatUserDateShort(value, prefs),
    formatDateTime: (value: string | Date | null | undefined) => formatUserDateTime(value, prefs),
  };
}
